<template>
  <div style="width:100%;height:100%;" id="data_source_con"></div>
</template>

<script>
  import axios from 'axios'

  const echarts = require('echarts');
  export default {
    name: 'dataSourcePie',
    mounted () {
      this.$nextTick(() => {
        var dataSourcePie = echarts.init(document.getElementById('data_source_con'));
        axios.get(`${this.$config.url}/dash/pie`)
          .then(res => {
            let piedata = [{
              value: res.data.ddl,
              name: 'DDL工单提交数',
              itemStyle: {
                normal: {
                  color: '#ed7996'
                }
              }
            },
              {
                value: res.data.dml,
                name: 'DML工单提交数',
                itemStyle: {
                  normal: {
                    color: '#78beea'
                  }
                }
              },
              {
                value: res.data.query,
                name: 'Query工单数',
                itemStyle: {
                  normal: {
                    color: '#76cabf'
                  }
                }
              }
            ];
            const option = {
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)'
              },
              legend: {
                orient: 'horizontal',
                left: 'center',
                bottom: 10,
                data: ['DML工单提交数', 'DDL工单提交数', 'Query工单数']
              },
              series: [
                {
                  avoidLabelOverlap: false,
                  name: '访问来源',
                  type: 'pie',
                  radius: ['40%', '80%'],
                  center: ['50%', '45%'],
                  data: piedata,
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  },
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  }
                }
              ]
            };
            dataSourcePie.setOption(option);
            window.addEventListener('resize', function () {
              dataSourcePie.resize();
            });
          })
          .catch(error => {
            this.$config.err_notice(this, error)
          })
      });
    }
  };
</script>
